import moment from "moment"
import { sortBy, reverse, sumBy, map } from "lodash"
import { TeamMember } from "./api"

type CountryCounts = { countryCode: string | undefined; count: number }[]

export const summarizeCountryCounts = (
  teamStats: TeamMember[],
): CountryCounts => {
  const countryCountsMap: { [countryCode: string]: number } = {}
  let countryNullCount = 0
  for (const { ip_country_code } of teamStats) {
    if (ip_country_code === null) {
      countryNullCount++
    } else if (ip_country_code in countryCountsMap) {
      countryCountsMap[ip_country_code]++
    } else {
      countryCountsMap[ip_country_code] = 1
    }
  }
  const countryCountsSortedArray = reverse(
    sortBy(
      map(countryCountsMap, (count, countryCode) => ({
        countryCode,
        count,
      })),
      ["count", "countryCode"],
    ),
  )
  if (countryCountsSortedArray.length <= 4 && countryNullCount === 0) {
    return countryCountsSortedArray
  }
  return [
    ...countryCountsSortedArray.slice(0, 3),
    {
      countryCode: undefined,
      count:
        sumBy(countryCountsSortedArray.slice(3), "count") + countryNullCount,
    },
  ]
}

type ClassesCounts = { classes: number; count: number }[]

export const summarizeClassesCounts = (
  teamStats: TeamMember[],
): ClassesCounts => {
  const classesCounts = [
    { classes: 1, count: 0 },
    { classes: 10, count: 0 },
    { classes: 100, count: 0 },
    { classes: Infinity, count: 0 },
  ]
  for (const { n_sessions } of teamStats) {
    for (const classesCount of classesCounts) {
      if (n_sessions <= classesCount.classes) {
        classesCount.count++
        break
      }
    }
  }
  return classesCounts
}

type Callouts = {
  birthdays: string[]
  newbies: string[]
  achievements: { nickname: string; n_sessions: number }[]
}

export const summarizeCallouts = (teamStats: TeamMember[]): Callouts => {
  const birthdays = []
  const newbies = []
  const unsortedAchievements = []
  for (const { nickname, n_sessions, birthday } of teamStats) {
    if (
      birthday !== null &&
      moment(birthday).date() === moment().date() &&
      moment(birthday).month() === moment().month()
    ) {
      birthdays.push(nickname)
    }
    if (n_sessions === 1) {
      newbies.push(nickname)
    } else if ([10, 100, 500, 1000].includes(n_sessions)) {
      unsortedAchievements.push({ nickname, n_sessions })
    }
  }
  const achievements = sortBy(unsortedAchievements, ["n_sessions", "nickname"])
  return { birthdays, newbies, achievements }
}
